import { useState } from "react";
import type { IOptionType } from "InterfacesTypes/interfaces";
import SelectSearchBar from "../selectSearchBar/SelectSearchBar";
import SearchResultCarousel from "../SearchResultCarousel";
import "./ResourceLinksList.css";

const ResourceLinksList = () => {
  const [selected, setSelected] = useState<IOptionType | null>(null);
  const [inputVal, setInputVal] = useState<string>("");

  return (
    <section id="startpageSearchSection" className="grid gap-3 !pb-[30px]">
      <div className="grid gap-3 rounded-[5px] p-2">
        <SelectSearchBar
          selected={selected}
          setSelected={setSelected}
          inputVal={inputVal}
          setInputVal={setInputVal}
        />
        <SearchResultCarousel
          setSelected={setSelected}
          setInputVal={setInputVal}
        />
      </div>
    </section>
  );
};
export default ResourceLinksList;
